module.exports = __webpack_public_path__ + "img/ee22a6f126487ed6c3ed5c5caaaa1355.png";